import '@/js/dist/www.iichi.com/common';

import Vue from 'vue';
import Tab from '@/js/components/like/tab.vue';

new Vue({
  el: '.like-tabs',
  components: {
    Tab,
  },
});
